import { render, staticRenderFns } from "./pro-progress-update.vue?vue&type=template&id=0bf8405d&scoped=true"
import script from "./pro-progress-update.vue?vue&type=script&lang=js"
export * from "./pro-progress-update.vue?vue&type=script&lang=js"
import style0 from "./pro-progress-update.vue?vue&type=style&index=0&id=0bf8405d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf8405d",
  null
  
)

export default component.exports